import { validations } from './validations';

const beerStyles = [
  { value: 'american lager', label: 'American Lager' },
  { value: 'apa', label: 'APA' },
  { value: 'bock', label: 'Bock' },
  { value: 'blonde ale', label: 'Blonde Ale' },
  { value: 'dubbel', label: 'Dubbel' },
  { value: 'dunkel', label: 'Dunkel' },
  { value: 'english pale ale', label: 'English Pale Ale' },
  { value: 'ipa', label: 'IPA' },
  { value: 'neipa / juicy ipa', label: 'NEIPA / Juicy IPA' },
  { value: 'ordinary bitter', label: 'Ordinary Bitter' },
  { value: 'pilsen', label: 'Pilsen' },
  { value: 'quadruppel', label: 'Quadruppel' },
  { value: 'red ale', label: 'Red Ale' },
  { value: 'saison', label: 'Saison' },
  { value: 'sour', label: 'Sour' },
  { value: 'stout ou porter', label: 'Stout ou Porter' },
  { value: 'tripel', label: 'Tripel' },
  { value: 'weissbier', label: 'Weissbier' },
  { value: 'witbier', label: 'Witbier' },
  { value: 'não lembro', label: 'Não lembro' },
];

/**
 * Questions about craft beer styles and preferences
 */
export const craftBeerQuestions = [
  {
    id: 'first-craft-style',
    question: 'Qual foi o primeiro estilo de cerveja ARTESANAL que você experimentou?',
    subtitle: 'Só escolha uma',
    type: 'radio',
    options: beerStyles,
    allowOther: true,
    nextQuestion: 'more-frequent-styles',
    validation: validations.required,
  },
  {
    id: 'why-dont-try-craft-beer',
    question: 'Por que razão você não consome cervejas artesanais?',
    type: 'radio',
    options: [
      { value: 'acho muito caras', label: 'Acho muito caras' },
      { value: 'não sei escolher', label: 'Não sei escolher' },
      { value: 'não encontro facilmente', label: 'Não encontro facilmente' },
      { value: 'acho muito amargas', label: 'Acho muito amargas' },
      { value: 'acho muito alcoólicas', label: 'Acho muito alcoólicas' },
      { value: 'meus amigos bebem cervejas comuns e prefiro acompanhá-los', label: 'Meus amigos bebem cervejas comuns e prefiro acompanhá-los' },
      { value: 'estou acostumado com o sabor do que já bebo e não tenho interesse em mudar', label: 'Estou acostumado com o sabor do que já bebo e não tenho interesse em mudar' },
    ],
    validation: validations.required,
    nextQuestion: (answer, allAnswers) => {
      if (allAnswers['common-beer'] === 'somente comuns') {
        return 'beer-listening-styles'
      }
      return 'went-to-beer-event'
    },
  },
  {
    id: 'more-frequent-styles',
    question: 'Quais estilos bebe com mais frequência hoje?',
    subtitle: 'marque até 3',
    type: 'sortable',
    options: beerStyles,
    allowOther: true,
    minSelections: 1,
    maxSelections: 3,
    validation: validations.sortableMinMax(1, 3),
  },
];
